export function formatLocationTime(
  value: string,
  context: { locale: string; time_zone: string },
  options: Pick<Intl.DateTimeFormatOptions, "dateStyle" | "timeStyle">,
): string {
  return new Intl.DateTimeFormat(context.locale, {
    ...options,
    timeZone: context.time_zone,
  }).format(new Date(value));
}
